
export default function HowItWorks() {
  // Scrolls smoothly to the booking section when called
  const scrollToBooking = () => {
    try {
      const bookingSection = document.getElementById('booking');
      if (bookingSection) {
        bookingSection.scrollIntoView({ behavior: 'smooth' });
      } else {
        console.warn('Booking section not found');
      }
    } catch (error) {
      console.error('Failed to scroll to booking section:', error);
    }
  };

  return (
    <section id="how-it-works" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-teal-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-list-ordered text-teal-600 text-lg"></i>
            <span className="text-teal-700 text-sm font-semibold">How It Works</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Book Your Appointment 3 Easy Ways
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Getting rid of your junk has never been easier. Choose the method that works best for you and we will take
            care of the rest.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {/* Step 1 - Call Us */}
          <div className="relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 text-center group">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg">
              1
            </div>
            <div className="w-20 h-20 bg-teal-50 rounded-2xl flex items-center justify-center mx-auto mt-4 mb-6 group-hover:bg-teal-100 transition-colors">
              <i className="ri-phone-line text-teal-600 text-4xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Call Us</h3>
            <p className="text-gray-600 text-sm leading-relaxed mb-6">
              Speak directly with our friendly team to schedule your junk removal appointment. We are happy to answer any
              questions and provide a free estimate over the phone.
            </p>
            <a
              href="tel:+19089021076"
              className="inline-flex items-center justify-center space-x-2 bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 shadow-md whitespace-nowrap cursor-pointer w-full"
            >
              <i className="ri-phone-line text-lg"></i>
              <span>Call (908) 902-1076</span>
            </a>
          </div>

          {/* Step 2 - Text Us */}
          <div className="relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 text-center group">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg">
              2
            </div>
            <div className="w-20 h-20 bg-teal-50 rounded-2xl flex items-center justify-center mx-auto mt-4 mb-6 group-hover:bg-teal-100 transition-colors">
              <i className="ri-message-3-line text-teal-600 text-4xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Text Us</h3>
            <p className="text-gray-600 text-sm leading-relaxed mb-6">
              Prefer texting? Send us a message with details about what you need removed. You can even include photos for a
              faster and more accurate estimate.
            </p>
            <a
              href="sms:+19089021076"
              className="inline-flex items-center justify-center space-x-2 bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 shadow-md whitespace-nowrap cursor-pointer w-full"
            >
              <i className="ri-message-3-line text-lg"></i>
              <span>Text (908) 902-1076</span>
            </a>
          </div>

          {/* Step 3 - Book Online */}
          <div className="relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 text-center group">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg">
              3
            </div>
            <div className="w-20 h-20 bg-teal-50 rounded-2xl flex items-center justify-center mx-auto mt-4 mb-6 group-hover:bg-teal-100 transition-colors">
              <i className="ri-calendar-check-line text-teal-600 text-4xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Book Online</h3>
            <p className="text-gray-600 text-sm leading-relaxed mb-6">
              Fill out our quick online form to request a free estimate. Upload photos of items you want removed and we
              will get back to you with a quote right away.
            </p>
            <button
              onClick={scrollToBooking}
              className="inline-flex items-center justify-center space-x-2 bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 shadow-md whitespace-nowrap cursor-pointer w-full"
            >
              <i className="ri-calendar-check-line text-lg"></i>
              <span>Book Online Now</span>
            </button>
          </div>
        </div>

        {/* Bottom Reassurance */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-6 bg-gray-50 rounded-2xl px-8 py-5 border border-gray-100">
            <div className="flex items-center space-x-2">
              <i className="ri-shield-check-line text-teal-600 text-xl"></i>
              <span className="text-gray-700 text-sm font-medium">Fully Insured</span>
            </div>
            <div className="w-px h-6 bg-gray-300"></div>
            <div className="flex items-center space-x-2">
              <i className="ri-money-dollar-circle-line text-teal-600 text-xl"></i>
              <span className="text-gray-700 text-sm font-medium">Free Estimates</span>
            </div>
            <div className="w-px h-6 bg-gray-300"></div>
            <div className="flex items-center space-x-2">
              <i className="ri-recycle-line text-teal-600 text-xl"></i>
              <span className="text-gray-700 text-sm font-medium">Eco-Friendly</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
